import type { AgentDerivedStatus } from 'types/agents';

const STATUS: Record<AgentDerivedStatus, { label: string; dot: string; text: string }> = {
  online: { label: 'Online', dot: 'bg-green-500', text: 'text-green-600' },
  away: { label: 'Borta', dot: 'bg-amber-500', text: 'text-amber-600' },
  full: { label: 'Fullt', dot: 'bg-amber-500', text: 'text-amber-600' },
  offline: { label: 'Offline', dot: 'bg-gray-400', text: 'text-gray-400' },
};

export function AgentStatusBadge({ status }: { status: AgentDerivedStatus }) {
  const s = STATUS[status];
  return (
    <span className={`inline-flex items-center gap-1.5 text-xs font-medium ${s.text}`}>
      <span className={`h-2 w-2 rounded-full ${s.dot}`} />
      {s.label}
    </span>
  );
}
